import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../models/payload";

export interface IAddRequestForm {
    transportTypeId: number;
    transportUnitNumber: string;
}

interface IAddRequestFormState {
    form: IAddRequestForm;
    showPopUp: string;
    popUpComponentId: string;
    loading:boolean;
}

const initialState: IAddRequestFormState = {
    form: {
        transportUnitNumber: "",
        transportTypeId: 0,
    },
    showPopUp: "",
    popUpComponentId: "",
    loading:false
};

export const addRequestFormReducer = createSlice({
    name: "addRequestFormReducer",
    initialState,
    reducers: {
        resetAddRequestForm: () => initialState,
        updateAddRequestProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.form = {
                ...state.form,
                [action.payload.name]: action.payload.value,
            };
        },
        setAddRequestShowPopUp: (state, action: PayloadAction<string>) => {
            state.showPopUp = action.payload;
        },
        setAddComponentId: (state, action: PayloadAction<string>) => {
            state.popUpComponentId = action.payload;
        },
        setLoadingCreateRequest: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },

    },
});

export const { resetAddRequestForm, updateAddRequestProperty, setAddRequestShowPopUp, setAddComponentId, setLoadingCreateRequest } = addRequestFormReducer.actions;

export default addRequestFormReducer.reducer;
